import React from "react";

function Checkout() {
    return (
        <div className="flex flex-col justify-center items-center h-screen bg-input text-white">
            <div className="animate-spin rounded-full h-32 w-32 border-b-4 border-[#7cf3a9]"></div>
            <p className="mt-8 text-xl font-medium text-[#7cf3a9]">Processing Checkout...</p>
        </div>
    );
}

export default Checkout;

